export default __webpack_public_path__ + "static/media/workingonit.09fe18f5.gif";